import React from 'react';
import './TextArea.scss';

interface TextAreaProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
}

const TextArea: React.FC<TextAreaProps> = ({
  label,
  value,
  onChange,
  required,
  error,
  disabled = false,
  placeholder,
  rows = 4,
  maxLength,
}) => {
  return (
    <div className="text-area-container">
      {label && (
        <label>
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <textarea
        className={`text-area-field${error ? ' with-error' : ''}${disabled ? ' disabled' : ''}`}
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
      />
      {error && <div className="text-area-error">{error}</div>}
    </div>
  );
};

export default TextArea;
